var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mensagem",class:{verde: _vm.verde}},[_vm._v(" "+_vm._s(_vm.conteudo)+" "),_c('span',{style:(_vm.verde ? 'color: white;' : '')},[_vm._v(_vm._s(_vm.horario))])])}
var staticRenderFns = []

export { render, staticRenderFns }